import { Button } from '@mui/material';
import { useState } from 'react';

import NewCatalogDialog from './NewCatalogDialog';

const NewCatalogButton = () => {
  const [open, setOpen] = useState(false);

  return (
    <>
      <Button
        sx={{ height: 44, minWidth: 100 }}
        size='large'
        variant='contained'
        color='primary'
        onClick={() => setOpen(true)}
      >
        New
      </Button>

      <NewCatalogDialog open={open} onClose={() => setOpen(false)} />
    </>
  );
};

export default NewCatalogButton;
